export const notAuthenticated = 'Not authenticated';
export const notAuthorized = 'Not authorized';
export const notConnected = 'Not connected';
export const invalidLicense = 'Invalid license';